import request from '../request'
import store from '../../store'

// 仪表盘-农机、驾证统计数据 (左侧8项数据)
export function getStatistic(params) {
  return request.get("/largescreen/govsupervision/getVehicleDriverStatistics", {...params, areaId : store.getters.getactiveRegionObj.areaCode}).then((res) => res);
}

// 各类型农机在册数(前十名)
export function getVehicleTotalCountByType(params) {
  return request.get("/largescreen/govsupervision/getVehicleTotalCountByType", {...params, areaId : store.getters.getactiveRegionObj.areaCode}).then((res) => res);
}

// 各类型农机检验数(前十名)
export function getVehicleTestCountByType(params) {
  return request.get("/largescreen/govsupervision/getVehicleTestCountByType", {...params, areaId : store.getters.getactiveRegionObj.areaCode}).then((res) => res);
}

// 各年度初次申领驾证数量
export function getLicenseApplyCountByYear(params) {
  return request.get("/largescreen/govsupervision/getLicenseApplyCountByYear", {...params, areaId : store.getters.getactiveRegionObj.areaCode}).then((res) => res);
}

// 各类型驾驶证申领数量同环比
export function getLicenseApplyCountRatio(params) {
  return request.get("/largescreen/govsupervision/getLicenseApplyCountRatio", {...params, areaId : store.getters.getactiveRegionObj.areaCode}).then((res) => res);
}

// 各区域驾证转入/转出数据对比
export function getLicenseInOutCountByArea(params) {
  return request.get("/largescreen/govsupervision/getLicenseInOutCountByArea", {...params, areaId : store.getters.getactiveRegionObj.areaCode}).then((res) => res);
}

// 历年发放行驶证数量
export function getDriverLicenseTotalCountByYear(params) {
  return request.get("/largescreen/govsupervision/getDriverLicenseTotalCountByYear", {...params, areaId : store.getters.getactiveRegionObj.areaCode}).then((res) => res);
}

// 累计注销与报废拆解情况统计 (旧的，不用)
export function getVehicleCancelCountByYear(params) {
  return request.get("/largescreen/govsupervision/getVehicleCancelCountByYear", {...params, areaId : store.getters.getactiveRegionObj.areaCode}).then((res) => res);
}

// 各季度农机注册与注销情况统计
export function getVehicleSeasonStatistic(params) {
  return request.get("/largescreen/govsupervision/getVehicleSeasonStatistic", {...params, areaId : store.getters.getactiveRegionObj.areaCode}).then((res) => res);
}

// 驾驶员画像
export function getDriverProfile(params) {
  return request.get("/largescreen/govsupervision/getDriverProfile", {...params, areaId : store.getters.getactiveRegionObj.areaCode}).then((res) => res);
}

// 农机、驾证统计数据(地图使用)
export function getAreaCountStatistics(params) {
  return request.get("/largescreen/govsupervision/getAreaCountStatistics", {...params, areaId : store.getters.getactiveRegionObj.areaCode}).then((res) => res);
}

// 获取字典
export function getDictData(dict) {
  return request.get(`/largescreen/job/type/${dict}`, ).then(res => res);
}